import { dailyKey, hashSeed, randomFrom, transformPuzzle } from "./engine.js";
import { JOURNEY_PUZZLES } from "./journey-puzzles.js";

/** Selection and identity only; the catalog does not generate or render boards. */
export class PuzzleCatalog {
  constructor(puzzles, { journey = JOURNEY_PUZZLES } = {}) {
    this.puzzles = puzzles;
    this.journey = journey;
  }
  get(id, variant = 0) {
    const base = [...this.puzzles, ...this.journey].find(
      (puzzle) => puzzle.id === id,
    );
    if (!base) throw new Error(`Unknown puzzle: ${id}`);
    return transformPuzzle(base, variant);
  }
  practice({ level = 1 } = {}) {
    if (!Number.isSafeInteger(level) || level < 1)
      throw new RangeError("Level must be a positive integer.");
    const index = level - 1;
    if (index < this.journey.length)
      return transformPuzzle(this.journey[index]);
    // Once the authored ramp is complete, stay on the advanced boards.
    const challenges = this.journey.slice(-8);
    const bonus = index - this.journey.length;
    return transformPuzzle(
      challenges[bonus % challenges.length],
      (1 + Math.floor(bonus / challenges.length)) % 8,
    );
  }
  daily(date = dailyKey()) {
    const random = randomFrom(hashSeed(`daily:${date}`));
    const choices = this.puzzles.filter(
      (puzzle) => puzzle.difficulty === "medium",
    );
    return transformPuzzle(
      choices[Math.floor(random() * choices.length)],
      Math.floor(random() * 8),
    );
  }
}
